import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { AuthContext } from "../../../../contexts";
import { AUDIENCE_GET_RESPONSE_DETIALS } from "../../../../endpoints";
import Loader from "../../../../organisms/loader/Loader";
import { formatDate, materialName } from "../../../utils/tools";

function Responses({ profile, materialFilter, onClearMaterialFilter }) {
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(true);
  const { token } = React.useContext(AuthContext);

  useEffect(() => {
    let isMounted = true;
    const fetchResponseData = async () => {
      try {
        const options = {
          url: `${AUDIENCE_GET_RESPONSE_DETIALS(profile?.id)}`,
          headers: {
            Authorization: token
          }
        };
        const response = await axios.request(options);
        if (isMounted) {
          setResponseData(response.data.records || []);
        }
      } catch (error) {
        console.error("Error fetching response data:", error);
        alert("An error occurred while fetching data. Please try again.");
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    if (profile?.id) {
      fetchResponseData();
    } else {
      setLoading(false);
    }

    return () => {
      isMounted = false;
    };
  }, [profile?.id, token]);

  const getMaterialName = (name) => materialName[name] || "";
  const formatAnswer = (attempt) => {
    if (attempt?.question?.type === 'attachment' && attempt?.answer === 'downloaded') {
      return 'Downloaded attachment';
    }
    const answer = attempt?.answer;
    if (Array.isArray(answer)) return answer.join(', ');
    if (typeof answer === 'boolean') return answer ? 'Yes' : 'No';
    if (answer === null || answer === undefined) return '';
    return answer;
  };

  const filteredResponseData = useMemo(() => {
    if (!materialFilter?.learning_material_id) return responseData;
    return responseData.filter(
      (item) => String(item.learning_material_id) === String(materialFilter.learning_material_id)
    );
  }, [materialFilter, responseData]);

  const filterLabel = materialFilter?.material_name
    ? `${getMaterialName(materialFilter.material_type)}: ${materialFilter.material_name}`
    : '';

  return (
    <div className="responses">
      <h5 className="title">Responses</h5>
      {materialFilter?.learning_material_id && (
        <div className="responses-filter-banner">
          <div className="responses-filter-text">
            Filtering by <b>{filterLabel}</b>
          </div>
          <button
            type="button"
            className="responses-filter-clear"
            onClick={() => onClearMaterialFilter?.()}
          >
            Clear
          </button>
        </div>
      )}
      {loading ? <Loader /> :
        <div className="content">
          {filteredResponseData.length === 0 ?
            <div className="item">
              {materialFilter?.learning_material_id ? "No Response Found for this material." : "No Response Found."}
            </div>
            : filteredResponseData.map((data, index) => {
              const resultValue = data?.attempt?.question?.result;
              return (
                <div className="item" key={index}>
                  <div className="left">
                    <h5>
                      {data?.attempt?.question?.description}
                      {" "}
                      ({getMaterialName(data?.learning_material_type)} : {data?.learning_material_name})
                      {resultValue !== undefined ? ` (Result: ${resultValue ? "Correct" : "Incorrect"})` : ""}
                    </h5>
                    <p>{formatAnswer(data?.attempt)}</p>
                  </div>
                  <div className="right">
                    <p>{formatDate(data?.attempt?.created_at)}</p>
                  </div>
                </div>
              )
            })}
        </div>
      }
    </div>
  );
}

export default Responses;
